import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftcardCartStepComponent } from './giftcard-cart-step.component';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';
import { PosTotalsModule } from 'src/app/shared/pos-totals/pos-totals.module';
import { PosAddGiftcardModalModule } from 'src/app/shared/pos-add-giftcard-modal/pos-add-giftcard-modal.module';



@NgModule({
  declarations: [
    GiftcardCartStepComponent
  ],
  imports: [
    CommonModule,
    PosTableModule,
    PosTotalsModule,
    PosAddGiftcardModalModule
  ],
  exports: [GiftcardCartStepComponent]
})
export class GiftcardCartStepModule { }
